"use client";

import { useEffect, useState } from "react";
import { useActiveWorkspaceScopeKey } from "@/lib/active-workspace";
import {
  getDefaultFlowState,
  getFlowState,
  subscribeToFlowStateChanges,
  type ConnectorFlowState,
} from "@/lib/connector-flow-state";

function getSnapshotForWorkspaceScope(
  workspaceScopeKey: string,
): ConnectorFlowState {
  if (workspaceScopeKey === "pending") {
    return getDefaultFlowState();
  }

  return getFlowState(workspaceScopeKey === "none" ? undefined : workspaceScopeKey);
}

export function useConnectorFlowSnapshot(): ConnectorFlowState {
  const workspaceScopeKey = useActiveWorkspaceScopeKey();
  const [, setSnapshotVersion] = useState(0);

  useEffect(() => {
    if (workspaceScopeKey === "pending") {
      return;
    }

    return subscribeToFlowStateChanges(() => {
      setSnapshotVersion((version) => version + 1);
    });
  }, [workspaceScopeKey]);

  return getSnapshotForWorkspaceScope(workspaceScopeKey);
}
